import { Col, FormGroup, Label } from 'reactstrap';
import React, { FunctionComponent, ReactNode, useState } from 'react';
import { compose } from 'recompose';
import { withApiData, ApiDataBinding } from 'react-api-data';
import { withTranslation, WithTranslation } from 'react-i18next';

// components
import FormControl from 'components/utils/FormControl';
import { ApiResponse, BannerApi } from 'constants/api';
import FormModal from './FormModal';

interface InProps {
    renderModalToggleBtn: (props: { onClick: () => void }) => ReactNode;
}
interface EnhanceProps {
    updateRequest: ApiDataBinding<ApiResponse<BannerApi>>;
    bannerDataBinding: ApiDataBinding<{ data: BannerApi }>;
}
type BannerProps = EnhanceProps & InProps & WithTranslation;

type FormValues = Pick<BannerApi, 'banner_text' | 'show_banner'>;

const enhance = compose<BannerProps, InProps>(
    withApiData({
        updateRequest: 'putBanner',
        bannerDataBinding: 'getBanner',
    }),
    withTranslation()
);

const BannerModal: FunctionComponent<BannerProps> = ({ bannerDataBinding, updateRequest, t, renderModalToggleBtn }) => {
    const [isOpen, setIsOpen] = useState(false);
    const banner = bannerDataBinding.data;

    if (!banner) {
        return <></>;
    }

    const initValues = { banner_text: banner.data.banner_text, show_banner: banner.data.show_banner };

    function toggle() {
        setIsOpen((isOpen) => !isOpen);
    }
    function onSubmit(values: FormValues) {
        return updateRequest.perform({}, { banner: values });
    }

    return (
        <React.Fragment>
            <FormModal
                header={t('banner.headerTitle')}
                isOpen={isOpen}
                toggle={toggle}
                initialValues={initValues}
                onSubmit={onSubmit}
                successMessage={t('notification.updateBannerSuccessful')}
            >
                {({ errors, touched }) => (
                    <React.Fragment>
                        <FormGroup row>
                            <Col md={2}>
                                <Label htmlFor="banner_text">{t('banner.bannerText')}</Label>
                            </Col>
                            <Col md={10}>
                                <FormControl
                                    component="textarea"
                                    name="banner_text"
                                    errors={errors}
                                    touched={touched}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col md={2}>
                                <Label htmlFor="banner_show">{t('banner.showBanner')}</Label>
                            </Col>
                            <Col md={1}>
                                <FormControl
                                    type="checkbox"
                                    name="show_banner"
                                    defaultChecked={initValues.show_banner}
                                    errors={errors}
                                    touched={touched}
                                />
                            </Col>
                        </FormGroup>
                    </React.Fragment>
                )}
            </FormModal>
            {renderModalToggleBtn({ onClick: toggle })}
        </React.Fragment>
    );
};

export default enhance(BannerModal);
